/* eslint-disable react/no-array-index-key */
import React, { memo, useMemo } from 'react';
import shortid from 'shortid';

import TableRow from 'common/ThemedTable/TableRow';

import isFunction from 'utils/isFunction';
import classNames from 'classnames';

const RowRenderer = ({
  row,
  index: i,
  renderBeginColumns,
  renderEndColumns,
  className,
  colSpan,
  renderCell,
  shouldHighlightRow,
}) => {
  const id = useMemo(() => shortid.generate(), []);
  const cells = [
    ...(isFunction(renderBeginColumns) ? renderBeginColumns(row, i) : []),
    ...(row?.map((element, j) => renderCell(element, i, j)) || []),
    ...(isFunction(renderEndColumns) ? renderEndColumns(row, i) : []),
  ];

  return (
    <TableRow
      key={id}
      cells={cells}
      className={classNames(className, { 'momentarily-highlighted': shouldHighlightRow })}
      colSpan={colSpan}
    />
  );
};

export default memo(RowRenderer);
